import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const GetUserPermission = ({ key, microAppPath = null }) => {

  const location = useLocation();
  const userPermission = useSelector((state) => state.auth.userPermission);
  const microAppList = useSelector((state) => state.admin.microAppList);

  const getPermission = (key) => {
    let pathName = location?.pathname?.split('admin/')
    let microApp = microAppPath || pathName?.at(1)?.split('/')?.at(0)
    let microAppLabel = microAppList?.filter((x) => x?.value == microApp)?.at(0)?.label
    let permissionStatus = userPermission?.filter((x) => x?.title == microAppLabel)?.at(0)?.[key]
    return permissionStatus;
  }

  return (
    getPermission(key)
  )
}

export default GetUserPermission